export const ID_EXTERNAL_TYPES = {
  globalEntity: 'GE',
  individual: 'p',
  collectiveC: 'C',
  collectiveE: 'E',
  isPartner: 'PRO',
  holder: 'HDR',
} as const
